module.exports = __webpack_public_path__ + "static/media/32735a15-2f61-4060-96d3-727ca153d735.35276c17.JPG";